import React, { useEffect, useState } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function ImportorSelect({ value, onChange, className = "" }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE_URL}/reklamasjon/importorer`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => {
        if (!cancelled) setOptions(Array.isArray(list) ? list : []);
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleAdd() {
    const navn = newName.trim();
    if (!navn) return;
    setSaving(true);
    try {
      const r = await fetch(`${API_BASE_URL}/reklamasjon/importorer`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ navn }),
      });
      if (!r.ok) throw new Error();
      const created = await r.json();
      setOptions((prev) => {
        if (prev.some((o) => o._id === created._id)) return prev;
        return [...prev, created].sort((a, b) => a.navn.localeCompare(b.navn, "nb"));
      });
      onChange(created.navn);
      setNewName("");
      setAdding(false);
    } catch {
      alert("Kunne ikke legge til importør.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className={className}>
      <div className="flex items-center gap-1.5">
        <select
          className="w-full border rounded p-2"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={loading}
        >
          <option value="">{loading ? "Laster…" : "Velg importør…"}</option>
          {options.map((o) => (
            <option key={o._id} value={o.navn}>{o.navn}</option>
          ))}
        </select>
        <button
          type="button"
          onClick={() => setAdding((v) => !v)}
          className="shrink-0 w-9 h-9 rounded border border-gray-300 text-gray-600 hover:bg-gray-50 flex items-center justify-center"
          title="Legg til ny importør"
        >
          +
        </button>
      </div>
      {adding && (
        <div className="flex items-center gap-1.5 mt-1.5">
          <input
            type="text"
            autoFocus
            className="w-full border rounded p-1.5 text-sm"
            placeholder="Navn på ny importør"
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleAdd();
              }
            }}
          />
          <button
            type="button"
            onClick={handleAdd}
            disabled={saving || !newName.trim()}
            className="shrink-0 text-xs px-2 py-1.5 rounded bg-green-600 text-white hover:bg-green-700 disabled:opacity-50"
          >
            {saving ? "…" : "Lagre"}
          </button>
          <button
            type="button"
            onClick={() => {
              setAdding(false);
              setNewName("");
            }}
            className="shrink-0 text-xs px-2 py-1.5 rounded border border-gray-300 text-gray-600 hover:bg-gray-50"
          >
            Avbryt
          </button>
        </div>
      )}
    </div>
  );
}
